"use strict";
/**
 * @license
 * Copyright 2016 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
export var ChunkState = /* @__PURE__ */ ((ChunkState2) => {
  ChunkState2[ChunkState2["GPU_MEMORY"] = 0] = "GPU_MEMORY";
  ChunkState2[ChunkState2["SYSTEM_MEMORY"] = 1] = "SYSTEM_MEMORY";
  ChunkState2[ChunkState2["SYSTEM_MEMORY_WORKER"] = 2] = "SYSTEM_MEMORY_WORKER";
  ChunkState2[ChunkState2["DOWNLOADING"] = 3] = "DOWNLOADING";
  ChunkState2[ChunkState2["QUEUED"] = 4] = "QUEUED";
  ChunkState2[ChunkState2["NEW"] = 5] = "NEW";
  ChunkState2[ChunkState2["FAILED"] = 6] = "FAILED";
  ChunkState2[ChunkState2["EXPIRED"] = 7] = "EXPIRED";
  return ChunkState2;
})(ChunkState || {});
export const numChunkStates = 8;
export var ChunkPriorityTier = /* @__PURE__ */ ((ChunkPriorityTier2) => {
  ChunkPriorityTier2[ChunkPriorityTier2["FIRST_TIER"] = 0] = "FIRST_TIER";
  ChunkPriorityTier2[ChunkPriorityTier2["FIRST_ORDERED_TIER"] = 0] = "FIRST_ORDERED_TIER";
  ChunkPriorityTier2[ChunkPriorityTier2["VISIBLE"] = 0] = "VISIBLE";
  ChunkPriorityTier2[ChunkPriorityTier2["PREFETCH"] = 1] = "PREFETCH";
  ChunkPriorityTier2[ChunkPriorityTier2["LAST_ORDERED_TIER"] = 1] = "LAST_ORDERED_TIER";
  ChunkPriorityTier2[ChunkPriorityTier2["RECENT"] = 2] = "RECENT";
  ChunkPriorityTier2[ChunkPriorityTier2["LAST_TIER"] = 2] = "LAST_TIER";
  return ChunkPriorityTier2;
})(ChunkPriorityTier || {});
export const numChunkPriorityTiers = 3;
export var ChunkDownloadStatistics = /* @__PURE__ */ ((ChunkDownloadStatistics2) => {
  ChunkDownloadStatistics2[ChunkDownloadStatistics2["totalTime"] = 0] = "totalTime";
  ChunkDownloadStatistics2[ChunkDownloadStatistics2["totalChunks"] = 1] = "totalChunks";
  return ChunkDownloadStatistics2;
})(ChunkDownloadStatistics || {});
export var ChunkMemoryStatistics = /* @__PURE__ */ ((ChunkMemoryStatistics2) => {
  ChunkMemoryStatistics2[ChunkMemoryStatistics2["numChunks"] = 0] = "numChunks";
  ChunkMemoryStatistics2[ChunkMemoryStatistics2["systemMemoryBytes"] = 1] = "systemMemoryBytes";
  ChunkMemoryStatistics2[ChunkMemoryStatistics2["gpuMemoryBytes"] = 2] = "gpuMemoryBytes";
  return ChunkMemoryStatistics2;
})(ChunkMemoryStatistics || {});
export const numChunkMemoryStatistics = 3;
export const numChunkDownloadStatistics = 2;
export const numChunkStatistics = numChunkStates * numChunkPriorityTiers * numChunkMemoryStatistics + numChunkDownloadStatistics;
export function getChunkStateStatisticIndex(state, priorityTier) {
  return state * numChunkPriorityTiers + priorityTier;
}
export function getChunkDownloadStatisticIndex(statistic) {
  return numChunkStates * numChunkPriorityTiers * numChunkMemoryStatistics + statistic;
}
export const PREFETCH_PRIORITY_MULTIPLIER = 1e13;
export const CHUNK_QUEUE_MANAGER_RPC_ID = "ChunkQueueManager";
export const CHUNK_MANAGER_RPC_ID = "ChunkManager";
export const CHUNK_SOURCE_INVALIDATE_RPC_ID = "ChunkSource.invalidate";
export const REQUEST_CHUNK_STATISTICS_RPC_ID = "ChunkQueueManager.requestChunkStatistics";
export const CHUNK_LAYER_STATISTICS_RPC_ID = "ChunkManager.chunkLayerStatistics";
export class LayerChunkProgressInfo {
  constructor() {
    this.numVisibleChunksNeeded = 0;
    this.numVisibleChunksAvailable = 0;
    this.numPrefetchChunksNeeded = 0;
    this.numPrefetchChunksAvailable = 0;
  }
}
